import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Y si conoce a alguien más en mi ausencia?',
    a: 'Si un hombre te reemplaza en 3 días de silencio, nunca fue tuyo. La Sombra filtra a los tibios y atrae a los comprometidos.'
  }, {
    q: '¿Es necesario borrarlo de redes?',
    a: 'No. El manual te enseña a usar tus redes como un arma de atracción silenciosa sin bloquearlo.'
  }, {
    q: '¿Funciona con ex parejas?',
    a: 'Sí, es la herramienta más potente para re-activar la curiosidad de un ex que cree que ya te "superó".'
  }];
  return <section className="py-20 bg-dark-100/50" data-id="element-48">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-49">
        <FadeIn data-id="element-50">
          <h2 className="text-3xl md:text-4xl font-serif text-center text-white mb-12" data-id="element-51">
            Preguntas <span className="text-gold-400 italic" data-id="element-52">Frecuentes</span>
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-53">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} index={index} data-id="element-54" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer,
  index
}: {
  question: string;
  answer: string;
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <FadeIn delay={index * 0.1} data-id="element-55">
      <div className="border border-gold-500/20 rounded-sm bg-dark overflow-hidden" data-id="element-56">
        <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-57">
          <span className="font-serif text-lg text-white" data-id="element-58">{question}</span>
          <ChevronDown className={`w-5 h-5 text-gold-400 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-59" />
        </button>

        <AnimatePresence data-id="element-60">
          {isOpen && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3
        }} data-id="element-61">
              <div className="p-6 pt-0 text-gray-400 leading-relaxed border-t border-gold-500/10" data-id="element-62">
                {answer}
              </div>
            </motion.div>}
        </AnimatePresence>
      </div>
    </FadeIn>;
}